import { Flex, Text } from "@chakra-ui/react";
import { Link } from "react-router-dom";
import { useTranslation } from "../i18n/LanguageContext";

export default function Footer() {
  const currentYear = new Date().getFullYear();
  const { t } = useTranslation();

  return (
    <Flex
      as="footer"
      backgroundColor={"background.grey"}
      borderTop={"1px solid"}
      borderColor={"divider.grey"}
      px={6}
      py={8}
      flexDirection={["column", "row"]}
      justifyContent={"space-between"}
      alignItems={["flex-start", "center"]}
      gap={6}
    >
      <Flex flexDirection={"column"} gap={1}>
        <Text fontWeight={"600"} fontSize={"16px"} color={"text.dark.grey"}>
          Bibliona
        </Text>
        <Text fontSize={"13px"} color={"text.medium.grey"}>
          {t("footer.description")}
        </Text>
        <Text fontSize={"12px"} color={"text.light.grey"} mt={2}>
          &copy; {currentYear} Bibliona. {t("footer.rights")}
        </Text>
      </Flex>

      <Flex
        as="nav"
        aria-label={t("footer.aria")}
        gap={6}
        flexWrap={"wrap"}
      >
        <Flex flexDirection={"column"} gap={2}>
          <Text fontWeight={"500"} fontSize={"14px"} color={"text.dark.grey"}>
            {t("footer.product")}
          </Text>
          <Link to="/features">
            <Text fontSize={"13px"} color={"text.medium.grey"} _hover={{ color: "fill.coral" }}>
              {t("nav.features")}
            </Text>
          </Link>
          <Link to="/pricing">
            <Text fontSize={"13px"} color={"text.medium.grey"} _hover={{ color: "fill.coral" }}>
              {t("nav.pricing")}
            </Text>
          </Link>
        </Flex>

        <Flex flexDirection={"column"} gap={2}>
          <Text fontWeight={"500"} fontSize={"14px"} color={"text.dark.grey"}>
            {t("footer.resources")}
          </Text>
          <Link to="https://support.bibliona.com/" target="_blank" rel="noopener noreferrer">
            <Text fontSize={"13px"} color={"text.medium.grey"} _hover={{ color: "fill.coral" }}>
              {t("nav.support")}
            </Text>
          </Link>
          <Link to={process.env.REACT_APP_BIBLIONA_URL} target="_blank" rel="noopener noreferrer">
            <Text fontSize={"13px"} color={"text.medium.grey"} _hover={{ color: "fill.coral" }}>
              {t("nav.signIn")}
            </Text>
          </Link>
        </Flex>
      </Flex>
    </Flex>
  );
}
